import React from 'react'
import { FaChartLine } from 'react-icons/fa'
import StarRating from '../../../StarRating'
import { StepCard, StepHeader, StepContent, StatusCard } from '../ModelPerformanceCard.styles'

interface PerformanceCardProps {
  gradients: {
    performance: string
  }
  bBoxRating: number
  modelState: string
  trainTime: string
  deploymentStatus: string
}

const PerformanceCard: React.FC<PerformanceCardProps> = ({
  gradients,
  bBoxRating,
  modelState,
  trainTime,
  deploymentStatus,
}) => {
  return (
    <StepCard>
      <StepHeader $gradient={gradients.performance}>
        Model Performance
        <FaChartLine />
      </StepHeader>
      <StepContent>
        <div className="performance-section mb-3">
          <div className="d-flex align-items-center gap-3">
            <div style={{ flex: '0 0 auto' }}>
              <StarRating rating={bBoxRating} small={false} />
            </div>
            <div
              style={{
                fontSize: '0.9rem',
                color: 'rgba(255, 255, 255, 0.7)',
                padding: '0.5rem 0.75rem',
                background: 'rgba(0, 0, 0, 0.2)',
                borderRadius: '4px',
                flex: 1,
              }}
            >
              Model Rating
            </div>
          </div>
        </div>

        <div className="performance-section">
          <div className="row g-2">
            <div className="col-12">
              <StatusCard>
                <span>Status</span>
                <strong>{modelState}</strong>
              </StatusCard>
            </div>
            <div className="col-6">
              <StatusCard>
                <span>Training Time</span>
                <strong>{trainTime}</strong>
              </StatusCard>
            </div>
            <div className="col-6">
              <StatusCard>
                <span>Deployment</span>
                <strong>{deploymentStatus}</strong>
              </StatusCard>
            </div>
          </div>
        </div>
      </StepContent>
    </StepCard>
  )
}

export default PerformanceCard
